import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProjectBusPriorityLoader,
    onSaveProjectBusPriority,
    onProjectBusPriorityClose,
} from 'actions/projectBusPriority';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError, initProps } from '../common';

const ProjectBusPriorityAdd = () => {
    const dispatch = useDispatch();
    const addProjectBusPriorityState = useSelector(state => state.projectBusPrioritys.addProjectBusPriorityState);
    const [selectedProjectBusPriority, setSelectedProjectBusPriority] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedProjectBusPriority(initProps());
    }, [addProjectBusPriorityState]);

    // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProjectBusPriority]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProjectBusPriorityField(name, value);
        validateField(name, value);
    };

    const updateSelectedProjectBusPriorityField = (fieldName, value) => {
        const newProjectBusPriority = { ...selectedProjectBusPriority };
        newProjectBusPriority[fieldName] = value;
        setSelectedProjectBusPriority(newProjectBusPriority);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProjectBusPriority));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProjectBusPriorityLoader());
                dispatch(onProjectBusPriorityClose());
                dispatch(onSaveProjectBusPriority(selectedProjectBusPriority));
                setSelectedProjectBusPriority(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProjectBusPriorityClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProjectBusPriority)}
                        {showErrors(formErrors)}
                        {inputFields(selectedProjectBusPriority, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addProjectBusPriorityState}>
            {modalHeader(<IntlMessages id="projectBusPriority.addProjectBusPriority" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="projectBusPriority.addProjectBusPriority" />)}
        </Modal>
    );
};

export default ProjectBusPriorityAdd;


// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd/index.js